export default __webpack_public_path__ + "static/media/no-domain.50b303e9.svg";